import allLanguages from './languages.json'
import { Language } from './types'

export const getLanguageList = () => {
  return allLanguages as Language[]
}

/**
 * Gets a full language object matching the given input, or an array of languages if input is an array
 * @param lang The locale(s), ISO code(s) or name(s) of the language(s) to find
 * @returns An array of language objects or `undefined` if input is an array, otherwise a language object or `undefined`
 */
export function getLanguage(lang: string): Language | undefined {
  if (!lang) return
  const langs = getLanguageList()
  return (
    langs.find((l) => l.ids.locale.toLowerCase() === lang.toLowerCase()) ??
    langs.find((l) => l.ids.ISO_639_1 === lang.toLowerCase()) ??
    langs.find((l) => l.ids.ISO_639_2 === lang.toLowerCase()) ??
    langs.find((l) => l.ids.ISO_639_3 === lang.toLowerCase()) ??
    langs.find((l) => l.ids.osxLocale.toLowerCase() === lang.toLowerCase()) ??
    langs.find((l) => l.ids.osxCode.toLowerCase() === lang.toLowerCase()) ??
    langs.find((l) => l.ids.androidCode.toLowerCase() === lang.toLowerCase()) ??
    langs.find((l) => l.ids.locale.toLowerCase().includes(lang.toLowerCase())) ??
    langs.find((l) => l.name.toLowerCase() === lang.toLowerCase()) ??
    langs.find((l) => l.name.toLowerCase().includes(lang.toLowerCase()))
  )
}
